import React, { Component } from 'react';
import { joinClasses } from 'components/utils/react_helper';

export default class SavingDots extends Component {
  render() {
    return (
      <span className={joinClasses(['saving-animation', this.props.className])}>
        <span className='saving-dot'>.</span>
        <span className='saving-dot'>.</span>
        <span className='saving-dot'>.</span>
      </span>
    );
  }
}